export enum CollapseFormDataHooks {
  FIRST_NAME = 'collapse-form-first-name',
  LAST_NAME = 'collapse-form-last-name',
  EMAIL = 'collapse-form-email',
  PHONE = 'collapse-form-phone',
  SECTION_NOTIFICATION = 'collapse-form-section-notification',
  EDIT_BUTTON = 'collapse-form-edit-button',
}
